import { AI_PROMPT_STATUS_FILTER } from '../../../constants';

const OPTIONS = [
  { value: AI_PROMPT_STATUS_FILTER.ALL, label: 'All' },
  { value: AI_PROMPT_STATUS_FILTER.ON, label: 'On' },
  { value: AI_PROMPT_STATUS_FILTER.OFF, label: 'Off' },
];

export const StatusFilter = ({ status, onChangeStatus }) => {
  return (
    <label className="flex items-center gap-1 rounded-full py-[11px] px-5 text-brand-900 border border-brand-900 font-medium text-[16px]/[24px] text-nowrap">
      Precision Conversation:
      <select
        value={status}
        onChange={e => {
          const { value } = e.target;
          onChangeStatus(prev => ({ ...prev, status: value }));
        }}
        className="bg-transparent outline-none cursor-pointer"
      >
        {OPTIONS.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
    </label>
  );
};
